// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3B","collapsed":"e_4B","body":"e_5B","row":"e_6B","cell":"e_7B","expanded":"e_8B"};